module.exports = __webpack_public_path__ + "static/media/25n.e868a06e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/25n.svg
// module id = 169
// module chunks = 0